import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ViewController} from 'ionic-angular';
import { ApiService } from "../../services/api.service";
import { FormGroup } from "@angular/forms";
import {ReportAddUnitPage} from "../report-add-unit/report-add-unit";

@Component({
  selector: 'page-report-search-unitmodel',
  templateUrl: 'report-search-unitmodel.html',
})
export class ReportSearchUnitmodelPage {

  searchPerformed = false;
  busy = false;
  form: FormGroup;
  reportAddUnitPage: ReportAddUnitPage;
  unitType = 1;

  query = '';
  items = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public apiService: ApiService
  ) {
    this.form = navParams.get('form');
    this.unitType = parseInt(navParams.get('unitType'));
    if(navParams.get('reportAddUnitPage')){
      this.reportAddUnitPage = navParams.get('reportAddUnitPage');
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportSearchUnitmodelPage');
  }

  search(){
    if(!this.query){
      return;
    }
    this.searchPerformed = false;
    this.items = [];
    this.busy = true;
    this.apiService.searchUnitVersion(this.query, this.unitType).then((data) => {
      this.busy = false;
      this.searchPerformed = true;
      // @ts-ignore
      this.items = data;
    }).catch(() => {
      this.busy = false;
      this.searchPerformed = true;
      this.alertCtrl.create({
        title: 'Fout',
        message: 'Er kon niet gezocht worden. Controleer uw internetverbinding.',
        buttons: ['OK']
      }).present();
    });
  }

  select(item){
    this.form.get('unit_brand').setValue(item.brand_title);
    this.form.get('unit_brand_id').setValue(item.unit_brand_id);
    this.form.get('unit_model').setValue(item.model_title);
    this.form.get('unit_model_id').setValue(item.unit_model_id);
    this.form.get('unit_version').setValue(item.title);
    this.form.get('unit_version_id').setValue(item.unit_version_id);
    // Set allow warranty by item.brand_warranty_status > 0
    if(this.reportAddUnitPage){
      if(parseInt(item.brand_warranty_status) > 0){
        this.reportAddUnitPage.setAllowWarranty(true);
      } else {
        this.reportAddUnitPage.setAllowWarranty(false);
      }
    }
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-search-unitmodel/report-search-unitmodel.ts